import React from 'react';
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import tableHeaders from 'components/AgreementsList/tableHeaders';
import Result from 'components/AgreementsList/Agreement/Result';
import { useTranslation } from 'react-i18next';
import TableBodyContent from 'common/TableBodyContent/TableBodyContent';
import { Agreement } from 'store/agreements/interfaces';

interface AgreementListProps {
  agreements: Agreement[];
  agreementsError: boolean;
  agreementsFetching: boolean;
}

function AgreementsList({
  agreements,
  agreementsError,
  agreementsFetching,
}: AgreementListProps) {
  const { t } = useTranslation();

  return (
    <TableContainer sx={{ px: 3, mt: 3, minHeight: 'calc(100vh - 31.3rem)' }}>
      <Table>
        <TableHead>
          <TableRow>
            {tableHeaders.map((header) => (
              <TableCell key={header.label} align={header.align}>
                <Typography variant="tableHeader" color="text.secondary">
                  {t(header.label)}
                </Typography>
              </TableCell>
            ))}
            <TableCell colSpan={tableHeaders.length} />
          </TableRow>
        </TableHead>
        <TableBodyContent
          isError={agreementsError}
          isFetching={agreementsFetching}
          tableHeaders={tableHeaders}
        >
          {agreements.map((agreement) => (
            <Result key={agreement.id} agreement={agreement} />
          ))}
        </TableBodyContent>
      </Table>
    </TableContainer>
  );
}

export default AgreementsList;
